import { StatList } from '../../../../../_components/StatList'
import { FormField } from '../../../../../_components/Forms/FormField'
import React from 'react'
import { scheduleTotalsConstants } from '../constants'

export const ScheduleTotals = ({ invoiceSchedule, isClientView }) => {
  const businessName = invoiceSchedule.business_name
  const batchTotal = invoiceSchedule.total_value
  const fundedTotal = invoiceSchedule.total_funded

  return (
    <StatList
      items={[
        !isClientView && {
          label: scheduleTotalsConstants.CLIENT_LABEL,
          type: null,
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="text"
              value={businessName}
            />
          ),
        },
        {
          label: scheduleTotalsConstants.INVOICES_TOTAL_LABEL,
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="currency"
              value={batchTotal}
            />
          ),
        },
        !isClientView && {
          label: scheduleTotalsConstants.FUND_TOTAL_LABEL,
          value: (
            <FormField
              className={'read-only-styles no-input-styles'}
              disabled={true}
              type="currency"
              value={fundedTotal}
            />
          ),
        },
      ]}
      layout="summary"
    />
  )
}
